import { supabase } from "@/lib/supabase";
import type { HeldSale } from "@/types";

const HELD_COLUMNS = "id, branch_id, user_id, customer_id, label, cart, notes, created_at, updated_at";

export interface SuspendSaleParams {
  branchId: string | null;
  userId: string;
  customerId: string | null;
  label: string;
  cart: unknown;
  notes?: string | null;
}

export async function suspendSale(params: SuspendSaleParams): Promise<{ ok: boolean; error: string | null; held?: HeldSale }> {
  try {
    const { data, error } = await supabase
      .from("held_sales")
      .insert({
        branch_id: params.branchId,
        user_id: params.userId,
        customer_id: params.customerId,
        label: params.label,
        cart: params.cart,
        notes: params.notes ?? null,
      })
      .select(HELD_COLUMNS)
      .maybeSingle();
    if (error || !data) return { ok: false, error: "No se pudo suspender la venta." };
    return { ok: true, error: null, held: data as HeldSale };
  } catch {
    return { ok: false, error: "Ocurrió un error inesperado al suspender la venta." };
  }
}

export async function loadHeldSales(branchId: string | null): Promise<HeldSale[]> {
  try {
    let query = supabase
      .from("held_sales")
      .select(HELD_COLUMNS)
      .order("created_at", { ascending: false })
      .limit(100);
    if (branchId) query = query.eq("branch_id", branchId);
    const { data, error } = await query;
    if (error) return [];
    return (data ?? []) as HeldSale[];
  } catch {
    return [];
  }
}

export async function deleteHeldSale(id: string): Promise<{ ok: boolean; error: string | null }> {
  try {
    const { error } = await supabase.from("held_sales").delete().eq("id", id);
    if (error) return { ok: false, error: "No se pudo eliminar la venta suspendida." };
    return { ok: true, error: null };
  } catch {
    return { ok: false, error: "Ocurrió un error inesperado al eliminar." };
  }
}